import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconNewspaper: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 2h13c.6 0 1 .4 1 1v16c0 1.7-1.3 3-3 3H5.5C3.6 22 2 20.4 2 18.5V9c0-.6.4-1 1-1h4V3c0-.6.4-1 1-1zm-4 8v8.5c0 .8.7 1.5 1.5 1.5S7 19.3 7 18.5V10H4zm15 10c.6 0 1-.4 1-1V4H9v14.5c0 .5-.1 1-.4 1.5H19zM17 9h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1zm-5 4h5c.6 0 1-.4 1-1s-.4-1-1-1h-5c-.6 0-1 .4-1 1s.4 1 1 1zm5 4h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
